import Link from 'next/link'

import { Shimmer } from '@wartek-id/shimmer'
import { Badge } from '@wartek-id/badge'
import { Icon } from '@wartek-id/icon'

import { useSETrackerEvent } from 'app/PelatihanMandiriPage/hooks/useSETrackEvent'

import type { TTopicNewest, TTopicNewestDetail } from 'types/microlearning'

interface TopicNewestProps extends Partial<TTopicNewest> {
  isLoading?: boolean
}

const TopicNewest = ({ topicData, title, isLoading }: TopicNewestProps) => {
  const { SETrackPromotionTopic } = useSETrackerEvent()

  const generateUrl = (topicId: number) => {
    return `/pelatihan-mandiri/topik/${topicId}`
  }

  const handleTracker = (topic: TTopicNewestDetail) => {
    SETrackPromotionTopic({
      action_type: 'click_promotion_topic',
      action_value: 'click_topic',
      topic_id: topic.topicID,
    })
  }

  if (isLoading) {
    return (
      <div>
        <Shimmer className="rounded-md mb-2" />
        <div className="py-4 px-4 bg-white rounded-md border border-gray-20 relative h-28">
          <div className="flex justify-between">
            <div>
              <Shimmer width={120} className="rounded-md mb-2" />
              <Shimmer className="rounded-md" />
            </div>
            <Shimmer className="rounded-md" height={64} width={64} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center mb-2">
        <div className="flex items-center">
          <img
            src="https://storage.googleapis.com/microlearning-public-production/web-assets/img-smartphone-star.png"
            height={24}
            width={24}
            alt="Topik Terbaru"
          />
        </div>
        <div className="flex-1 ml-2">
          <div className="font-semibold text-lg">{title}</div>
        </div>
      </div>
      {(topicData || []).map((topic, idx) => (
        <div
          key={`topic-newest-${idx}`}
          className="mb-4"
          onClick={() => handleTracker(topic)}
        >
          <Link href={generateUrl(topic.topicID)} passHref>
            <div className="py-4 px-4 bg-white rounded-md border border-gray-20 relative">
              {topic.label && (
                <Badge
                  className="absolute -top-3 right-0 z-10"
                  variant="informational"
                >
                  {topic.label}
                </Badge>
              )}
              <div className="flex">
                <div className="font-semibold flex-1">{topic.topicName}</div>
                <div className="flex-none">
                  {topic.imagePath && (
                    <img
                      src={topic.imagePath}
                      className="rounded-md object-cover"
                      height={64}
                      width={64}
                      alt={title}
                    />
                  )}
                </div>
              </div>
              <div className="flex items-center mt-2">
                <Icon fontSize="sm">library_books</Icon>
                <div className="text-sm ml-2 font-semibold text-gray-60">
                  {topic.totalModule} modul
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default TopicNewest
